export default {
  UPDATE_MENTOR_RATING_SUCCESS: "Your mentor rating has been recorded. Thank you.",
  deferMentorRatingSuccess: (duration) =>
    `We will remind you in ${duration} day${parseInt(duration, 10) !== 1 ? "s" : ""}.`,
  ERROR_UPDATING_MENTOR_RATING: "There was an error recording your mentor rating",
  ERROR_DEFERRING_MENTOR_RATING: "There was an error handling your request",
};
